import React, { ReactNode } from 'react';
import moment from 'moment';
import { DateFormats } from 'constants/common';
import { red, green } from '@mui/material/colors';
import { Typography, Stack } from '@mui/material';
import { Close, DoneAll } from '@mui/icons-material';

import { ClosedDealData } from '../api/dealLifeCycle';

const renderByStatus: Record<
  'SUCCESS' | 'FAILED',
  {
    icon: ReactNode;
    bgColor: string;
    borderColor: string;
    prefix: 'Won' | 'Lost';
    textColor: 'error' | 'success';
  }
> = {
  SUCCESS: {
    prefix: 'Won',
    bgColor: green[50],
    textColor: 'success',
    borderColor: green[100],
    icon: <DoneAll color="success" />,
  },
  FAILED: {
    prefix: 'Lost',
    bgColor: red[50],
    textColor: 'error',
    borderColor: red[100],
    icon: <Close color="error" />,
  },
};

export const ClosedDealInfo = ({ closeDealStatus, closedDateTime, reasonLabel, editNode }: ClosedDealData) => (
  <Stack
    sx={{
      gap: '0.5rem',
      alignItems: 'center',
      flexDirection: 'row',
      padding: '2px 0.5rem',
      borderRadius: '0.3rem',
      backgroundColor: renderByStatus[closeDealStatus].bgColor,
      border: `1px solid ${renderByStatus[closeDealStatus].borderColor}`,
    }}
  >
    {renderByStatus[closeDealStatus].icon}

    <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
      {renderByStatus[closeDealStatus].prefix}: {moment(closedDateTime).format(DateFormats.TimeWithShortDate)}
    </Typography>

    <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
      {reasonLabel}
    </Typography>

    {editNode}
  </Stack>
);
